import ResearchService from 'src/modules/research/researchService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'RESEARCH_VIEW';

const researchViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: researchViewActions.FIND_STARTED,
      });

      const record = await ResearchService.find(id);

      dispatch({
        type: researchViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: researchViewActions.FIND_ERROR,
      });

      getHistory().push('/research');
    }
  },
};

export default researchViewActions;
